module.exports = __webpack_public_path__ + "img/plate.be5030ca.webp";